// extracted by mini-css-extract-plugin
module.exports = {"desktopOptionList":"TypeSelectorMobile_desktopOptionList__Gv2LD","desktopWrapper":"TypeSelectorMobile_desktopWrapper__dsqjZ"};